// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"c405fed4","787":"ae9294bf"}[chunkId] + ".chunk.js";
};